import { Component, Input } from '@angular/core';
import { faWhatsapp, faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { faMobileScreen } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cta',
  templateUrl: './cta.component.html',
  standalone: false,
  styleUrl: './cta.component.scss'
})
export class CtaComponent {
  @Input() title = '¿Listo para modernizar tu fraccionamiento?';
  @Input() subtitle = 'Solicita una demostración gratuita sin compromiso. Te atendemos por WhatsApp.';
  @Input() showAppBadges = true;

  contact = environment.contact;
  appLinks = environment.appLinks;
  faWhatsapp = faWhatsapp;
  faApple = faApple;
  faGooglePlay = faGooglePlay;
  faMobileScreen = faMobileScreen;
}
